import React from "react";
import { DotLoader } from "react-spinners";

import "./Spinner.scss";
import { blueGrey } from "@mui/material/colors";

const Spinner = () => {
  return (
    <React.Fragment>
      <div className="spinner">
        <DotLoader color={blueGrey[500]} className="dotloader" />
        <p className="spinner-text">Loading...</p>
      </div>
    </React.Fragment>
  );
};

export default Spinner;
